import { ConnectedReferenceActivityCard } from "@adsk/acc-reference-picker";
import React from "react";
import { useReferencePickerPlugins } from "../../../input-field-components/ReferencePickerField/useReferencePickerPlugins";
import { ActivityLogCardProps } from "../activityLogTypes";

export const ChangedReferenceActivityCard = ({
  activityChange,
  title, // Omit title from props so it won't be passed
  ...props
}: ActivityLogCardProps) => {
  const plugins = useReferencePickerPlugins();
  const { before, after } = activityChange;
  const value = after || before; // One of them is an empty string, the other contains our change value
  const { entityId, entityDomain, entityType } = value;

  return (
    <ConnectedReferenceActivityCard
      {...props}
      /* Used by globals.ts to amend UI issues until https://jira.autodesk.com/browse/WPLT-1164 is fixed */
      className="IssuesActivityLog__activity-card"
      entityId={entityId}
      entityDomain={entityDomain}
      entityType={entityType}
      plugins={plugins}
      variant={
        !before && after
          ? ConnectedReferenceActivityCard.VARIANTS.ADDED
          : ConnectedReferenceActivityCard.VARIANTS.REMOVED
      }
    />
  );
};
